module.exports = __webpack_public_path__ + "static/organicleafmulti-eb2e0dc7a82db7c3d5b64b548d6c2aa9.jpeg";